/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerFindAllQueryResponse, SummarizationsControllerFindAllPathParams, SummarizationsControllerFindAllQueryParams, SummarizationsControllerFindAll401, SummarizationsControllerFindAll403 } from "../../models/documentSummariesController/SummarizationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { summarizationsControllerFindAll } from "../../clients/document-summariesService/summarizationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const summarizationsControllerFindAllQueryKey = (documentId: SummarizationsControllerFindAllPathParams["documentId"], renditionId: SummarizationsControllerFindAllPathParams["renditionId"], params: SummarizationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/summaries',
  params: {
    documentId: documentId,
    renditionId: renditionId
  }
}, ...(params ? [params] : [])] as const;
export type SummarizationsControllerFindAllQueryKey = ReturnType<typeof summarizationsControllerFindAllQueryKey>;
export function summarizationsControllerFindAllQueryOptions(documentId: SummarizationsControllerFindAllPathParams["documentId"], renditionId: SummarizationsControllerFindAllPathParams["renditionId"], params?: SummarizationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = summarizationsControllerFindAllQueryKey(documentId, renditionId, params);
  return queryOptions<SummarizationsControllerFindAllQueryResponse, ResponseErrorConfig<SummarizationsControllerFindAll401 | SummarizationsControllerFindAll403>, SummarizationsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return summarizationsControllerFindAll(documentId, renditionId, params, config);
    }
  });
}

/**
 * @description Returns summaries with JSON:API pagination, sorting, and filtering
 * @summary List all summaries for a rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries}
 */
export function useSummarizationsControllerFindAll<TData = SummarizationsControllerFindAllQueryResponse, TQueryData = SummarizationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = SummarizationsControllerFindAllQueryKey>(documentId: SummarizationsControllerFindAllPathParams["documentId"], renditionId: SummarizationsControllerFindAllPathParams["renditionId"], params?: SummarizationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<SummarizationsControllerFindAllQueryResponse, ResponseErrorConfig<SummarizationsControllerFindAll401 | SummarizationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? summarizationsControllerFindAllQueryKey(documentId, renditionId, params);
  const query = useQuery({
    ...summarizationsControllerFindAllQueryOptions(documentId, renditionId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SummarizationsControllerFindAll401 | SummarizationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}